import templateUrl from 'servicestack/auto-query/auto-query-radio-filter.htm';
import basicController from 'servicestack/basic.controller.properties';
import $pageConfig from 'webutils/services/page-config'

class controller {
    constructor() {
        const $ctrl = this;
        basicController($ctrl);
    }
};

export default {
    bindings: {
        filter: '<'
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};